import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/SchoolProgram/2024/orientation/1.jpg';
// import p2 from 'assests/Photos/SchoolProgram/2024/orientation/2.jpg';
// import p3 from 'assests/Photos/SchoolProgram/2024/orientation/3.jpg';
// import p4 from 'assests/Photos/SchoolProgram/2024/orientation/4.jpg';
// import p5 from 'assests/Photos/SchoolProgram/2024/orientation/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2024/orientation/6.jpg';


// import p5 from 'assests/Photos/SchoolProgram/2023/Valediction_ceremony/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2023/RepublicDay/6.jpg';
// import p7 from 'assests/Photos/SchoolProgram/2023/RepublicDay/7.jpg';
// import p8 from 'assests/Photos/SchoolProgram/2023/RepublicDay/8.jpg';
// import p9 from 'assests/Photos/SchoolProgram/2023/RepublicDay/9.jpg';
// import p10 from 'assests/Photos/SchoolProgram/2023/RepublicDay/10.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const NationalSportsDay2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/NationalSports/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/NationalSports/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/NationalSports/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/NationalSports/4.webp`;
    const p5  = `${config.base_image_url_2025}/home/events-activities/school-programs/NationalSports/5.webp`;
    const p6  = `${config.base_image_url_2025}/home/events-activities/school-programs/NationalSports/6.webp`;
    const p7  = `${config.base_image_url_2025}/home/events-activities/school-programs/NationalSports/7.webp`;
    const p8  = `${config.base_image_url_2025}/home/events-activities/school-programs/NationalSports/8.webp`;
    const p9  = `${config.base_image_url_2025}/home/events-activities/school-programs/NationalSports/9.webp`;


   
    const photos = [
         {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
}, 
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
},
{
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},
{
  src: p9,
  source: p9,
  rows: 1,
  cols: 1,
}

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                               National Sports Day 
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                              Date: 3 September 2025
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                National Sports Day was celebrated with great enthusiasm and energy at NATIONAL PUBLIC SCHOOL YESHWANTPUR on 29th August 2025 to commemorate the birth anniversary of the legendary hockey player Major Dhyan Chand, also known as the "Wizard of Hockey." Students gathered with a sense of pride and excitement. A brief speech was delivered by the Head Girl, highlighting the significance of National Sports Day and the legacy of Major Dhyan Chand. This was followed by a sportsmanship pledge, where all students and teachers solemnly took an oath to uphold the spirit of fair play, teamwork, and dedication in sports and life.
                                <br></br>
                                The sports ground came alive with a range of fun-filled and competitive activities organized for different age groups. Events included: 100m and 200m sprints, Sack race and lemon-spoon race for junior classes, Relay races, Tug of war between students and teachers, Yoga and fitness drills for all classes. 
                                <br></br> <br></br>
                                A motivating talk was delivered by the Sports Coordinator, who emphasized the role of discipline, regular practice, and physical fitness in shaping not just athletes but responsible individuals. The teacher also shared interesting stories from the life of Major Dhyan Chand to inspire students.
                               <br></br>
                                To promote a broader understanding of sports, the school also organized: Poster-making and slogan-writing competitions on the theme “Fitness for All” and Quiz competition on Indian sports personalities.
                              <br></br> <br></br>
                                The celebration successfully highlighted the importance of incorporating sports into our daily lives. It instilled a sense of unity, healthy competition, and respect for physical well-being among the students. The Principal, in the closing speech, appreciated the efforts of the organizing committee and encouraged students to continue participating in sports with the same zeal throughout the year. 
                               <br></br>
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “National Sports Day at National Public School, Yeshwanthpur was truly a day of fun, learning, and inspiration.”

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 500}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default NationalSportsDay2025;